import AddSubjektBezPripomienokAdmin from './AddSubjektBezPripomienokAdmin';

export default AddSubjektBezPripomienokAdmin;
